import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FleetChargingFigureService } from 'src/app/_services/fleet-charging-figure.service';
import { BatteryTypeOption, toBatteryTypeFilter, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-charged-energy-over-time-chart',
  templateUrl: './charged-energy-over-time-chart.component.html',
  styleUrls: ['./charged-energy-over-time-chart.component.scss']
})
export class ChargedEnergyOverTimeChartComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  errorMessage: boolean = false;
  dataLoading: boolean = false;
  numberMonths: number = 0;
  
  constructor(
    private readonly fleetChargingFigureService: FleetChargingFigureService
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  ngOnChanges(): void {
    this.dataLoading = true;
    this.errorMessage = false;
    this.fleetChargingFigureService.getChargedEnergyFleet(this.fleetId, toBatteryTypeFilter(this.selectedBatteryTypes)).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.plotchargedEnergyOverTimeChart(datapoints);
        },
        error: (error) => {
          console.error('Error fetching Charged Energy over Time Fleet data:', error);
          this.dataLoading = false;
          this.errorMessage = true;
        },
        complete: () => {
          this.dataLoading = false;
        }
      }
    )
  }
  
  plotchargedEnergyOverTimeChart(datapoints: any) {
    const data = toBatteryTypeSeries(datapoints, this.selectedBatteryTypes).map((series) => {
      const plotData = this.sortByTime(series.datapoints);
      const monthLabels = plotData.map((dataObject: any) =>
        new Date(dataObject.month).toLocaleString('default', { month: 'short', year: 'numeric' }));

      this.numberMonths = Math.max(this.numberMonths, monthLabels.length);

      return {
        x: monthLabels,
        y: plotData.map((dataObject: any) => dataObject.energy),
        type: 'bar',
        name: series.label,
        marker: {
          color: series.color
        }
      };
    });
    
    const layout = {
      title: 'Charged Energy over Time',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'Time [Months]',
      },
      yaxis: {
        title: 'Energy [kWh]'
      },
      showlegend: true,
      legend: {
        orientation: 'h', 
        y: -0.3, 
        xanchor: 'center', 
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
    createPlotlyChart('charged-energy-over-time', data, layout);
  }
  
  sortByTime(data: any[]): any[] {
    return data.slice().sort((a, b) => new Date(a.month).getTime() - new Date(b.month).getTime());
  }
  
}